
export const environment = {
    production: false,
    envUrl: '/sandbox',
    baseUrl: 'https://x2xdev.x2xecommerce.com/pp/sandboxapi',
    qbBaseUrl: 'https://partners.x2xecommerce.com/sandbox/qbapi/api/',
    qbIntuitUrl: 'https://appcenter.intuit.com/connect/oauth2?client_id=ABDttMpXDWkKcKeK6DsVEwPeOETrpP1vSLd3Gq9RE0waWxvbfR&redirect_uri=https%3A%2F%2Fpartners.x2x-ecommerce.com%2Fsandbox%2Fqbapi%2Fapi%2FIntuit%2Foauthcallback&response_type=code&scope=com.intuit.quickbooks.accounting%20openid%20profile%20email%20phone&state=nSUag%252FIh8QINpcPR1H7vfb1O7%252BhUE5m%252FP8m1wCVRlAHa7Kkk48uC72byN0VRdF1V3bjLaO%252F35szlFJKDAi4jgmdsCD7gUsFCMk%252Brtm4KIvQKUPjB%252BVgsj3ZYU8GeX4aUOnHL%252F%252BhSsqVqFbh9O5yIbknYMqkbOp1SV%252BzenDebiKvKuq%252B74TFCtoBBnZVR1wBv2JmL8gsYYTCcRJ80s6yWI4Zzm4WmixkFN7M32WcJ1K6CSlAFgDlSiSCjMWvSy6xPAhXZsnfzYX%252B5kNAWVr4MQg%253D%253D',
    productBaseUrls: {
        '8': 'https://partners.x2xecommerce.com/sandbox/qbapi/api/',
      
    },
    backToAppProductIds: ['8']
};
